import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21.015 3.035l-16.515 16.465","key":"svg-0"}],["path",{"d":"M3.173 17.619a4.63 4.63 0 0 0 3.284 3.26a4.67 4.67 0 0 0 4.487 -1.194c1.85 -1.836 4.07 -10.65 4.07 -10.65s-8.88 2.296 -10.639 4.132a4.59 4.59 0 0 0 -1.202 4.452","key":"svg-1"}]]

const IconWhisk = createReactComponent('outline', 'whisk', 'Whisk', __iconNode);

export default IconWhisk;